export default {
  lang: 'Lingua',
  currency: 'Valuta',
  validGoodUrlFail: 'questo non è un link di prodotto valido',
  product: 'prodotti',
  productHolder: 'Inserisci nome/link del prodotto',
  shop: 'Negozio',
  shopHolder: 'Inserisci nome/link del negozio',
  purchaseAgent: 'Home',
  transport: 'Rispedizione',
  manualOrdering: 'Ordine Fai da Te',
  guideBook: "Guida all'uso",
  help: 'Aiuto',
  tools: 'Strumenti',
  customerService: 'Servizio clienti',
  purchaseGuide: "Guida all'agente d'acquisto",
  payment: 'Pagamento',
  delivery: 'Spedizione',
  afterSaleService: 'Servizio post-vendita',
  insuranceCompensation: 'Assicurazione e risarcimento',
  contactInfo: 'Informazioni di contatto',
  enterEmail: 'Inserisci la tua e-mail',
  copyRight: 'Copyright©acbuy.com Tutti i diritti riservati',
  aboutacbuy: 'Informazioni su acbuy',
  contctTime: '9/7 (09:00-18:00, ora di Pechino)',
  contactEmail: "E-mail del servizio clienti: Support{'@'}acbuy.com",
  contactMarket: "Collaborazione marketing: Marketing{'@'}acbuy.com",
  contactCooperation: "Collaborazione commerciale: Business{'@'}acbuy.com",
  tutorial: 'Tutorial',
  serviceFee: 'Costo del servizio',
  orderStatus: 'Guida per i nuovi utenti',
  returnRefunds: 'Resi e rimborsi',
  topUp: 'Ricarica',
  paypal: 'PayPal',
  internationalCreditCard: 'Carta di credito internazionale',
  telegraphicTransfer: 'Bonifico telegrafico',
  charges: 'Costi',
  mailRestrictions: 'Restrizioni postali',
  customsTaxation: 'Dogana e tasse',
  receiptInformation: 'Informazioni sulla ricevuta',
  helpCenter: 'Centro assistenza',
  contactUs: 'Contattaci',
  registerSuccess: 'Registrazione avvenuta con successo',
  registerMsg:
    "Abbiamo inviato un'e-mail di verifica al tuo indirizzo. Effettua la verifica il prima possibile, altrimenti ciò influenzerà il normale utilizzo dei tuoi punti.",
  continueShopping: 'Continua lo shopping',
  continueLogin: "Continua l'accesso",
  verifyQuestion: "Non hai ricevuto l'e-mail di verifica?",
  verifyResopnseOne:
    "· L'e-mail di verifica di acbuy potrebbe essere considerata spam, controlla la tua cartella spam",
  verifyResopnseTwo:
    '· La consegna a volte può subire ritardi di alcuni minuti, ti preghiamo di attendere',
  verifyResopnseThird:
    "· L'e-mail di verifica potrebbe subire ritardi di alcuni minuti. Se non l'hai ricevuta da molto tempo, puoi verificare se è stata contrassegnata come spam o inviare nuovamente l'e-mail di verifica",
  agentGuide: "Guida dell'agente per i nuovi utenti",
  guideBookbtn: 'Guida per principianti',
  everyonePro: 'Registrati ora e ricevi un regalo di benvenuto di 2280 ¥!',
  joinAffiliate: 'Unisciti ora',
  joinacbuy: 'Unisciti ad acbuyDiscord per ottenere maggiori vantaggi',
  joinDiscord: 'Unisciti a Discord',
  productPpurchase: 'Acquisto prodotti',
  shippingToWarehouse: 'Spedizione al magazzino',
  qualityAssurance: 'Garanzia di qualità',
  moreCostEffective: 'Più conveniente',
  productPpurchaseContent:
    'Acquisto prodotti - puoi acquistare facilmente qualsiasi articolo su TaoBao. Basta incollare i link dei prodotti TaoBao sul sito web di acbuy ed effettuare un ordine. Acbuy acquisterà per te.',
  shippingToWarehouseContent:
    'Spedizione al magazzino - Acquista da diversi venditori con il nostro servizio e raggrupperemo in modo efficiente i tuoi ordini. Tutti gli articoli verranno spediti al magazzino designato di Acbuy e semplificheremo il processo per la tua comodità.',
  qualityAssuranceContent:
    "Garanzia di qualità - Una volta che i tuoi prodotti arrivano al magazzino designato di Acbuy, effettueremo un'ispezione di qualità completa e ti invieremo il rapporto di ispezione per offrirti una migliore esperienza d'uso.",
  moreCostEffectiveContent:
    'La spedizione consolidata fa risparmiare denaro - nel tuo magazzino, puoi selezionare liberamente le merci e spedirle in un unico pacco. Con il servizio di spedizione globale di acbuy, puoi spedire le merci ovunque e godere di una spedizione globale più semplice e affidabile.',
  introduction: 'Acquistare su Taobao tramite acbuy',
  logoIntroduction: 'Fai acquisti come un milionario.',
  reviewOn: 'Recensioni su',
  productStoragePeriod: 'Periodo di stoccaggio dei prodotti',
  inspectionRules: 'Regole di ispezione',
  afterSalesPolicy: 'Politica post-vendita',
  insuranceAndCompensation: 'Assicurazione e risarcimento',
  oneStopService: 'Servizio unico',
  whatCustomersSay: 'Cosa dicono i nostri clienti',
  customerSay1:
    "acbuy è il miglior agente d'acquisto che abbia mai usato - è la prima volta che uso acbuy e i suoi prodotti sono più economici di qualsiasi altro agente d'acquisto, il che è davvero incredibile!",
  customerSay2:
    'Dopo essere diventato promotore acbuy, ho ricevuto un cashback di 300 yuan. Dopodiché, riceverò almeno il 4% di cashback su ogni ordine',
  customerSay3:
    "Un'esperienza di acquisto molto piacevole - ho usato acbuy per acquistare dalla Cina prodotti di buona qualità, un eccellente servizio clienti e una spedizione veloce.",
  customerSay4:
    "Il miglior agente - l'acquisto è stato effettuato lo stesso giorno. Ci sono voluti solo 7 giorni per spedire il pacco a casa mia. È il miglior agente attualmente",
  customerFirst: 'Il cliente prima di tutto, servizio premium',
  customerServiceText: 'Servizio clienti online 9/7 (09:00-18:00, ora di Pechino)',
  faqCategory: 'CATEGORIE FAQ',
  valentine: 'Delizie della scatola misteriosa di San Valentino',
  joinDiscordNew: 'UNISCITI A DISCORD',
  valentineTip: 'Unisciti a Discord per regali esclusivi',
  inviteNow: 'Invita ora',
  comeHere: 'Sblocca incredibili ricompense!',
  viewTutorial: 'Visualizza il tutorial',
  springText1: 'Come acquistare su Taobao con Acbuy',
  springText2: 'Invita amici e guadagna 2000 ¥ in contanti',
  springText3: "Durata dell'evento: 18 aprile - 20 maggio",
  category: 'Categoria',
  hotSale: 'Prodotti in promozione',
  motherText1: 'Offerte esclusive per la Festa della Mamma',
  motherText2: 'Vinci premi - Partecipa ora!',
  motherText3: "Durata dell'evento: 30 aprile - 13 maggio",
  enterNow: 'Partecipa ora',
  'i18n-000001': 'Effettua ordini',
  'i18n-000002': "Incolla un link all'articolo per inviare un ordine",
  'i18n-000003': 'CQ e stoccaggio',
  'i18n-000004': '3-5 foto CQ gratuite e 90 giorni di stoccaggio gratuito',
  'i18n-000005': 'Invia pacchi',
  'i18n-000006': 'Imballaggio consolidato e verifica del pacco',
  'i18n-000007': 'Spedizione internazionale',
  'i18n-000008': 'Linea più economica con oltre 150 linee di spedizione',
  loveText1: 'Unisciti alla Corsa del 520',
  loveText2: 'Ordini grandi, prezzi più grandi!',
  loveText3: "Durata dell'evento: 14 maggio - 24 maggio",
  couponResult: 'Trovati {num} risultati per "{keyword}"',
  event: 'Eventi',
}
